import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import NFormatterFun from './Formatter';
import barPalette from 'assets/js/palette';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface VerticalBarChartProps {
  chartData: any;
  /** One bar per category with the series piled on top of each other, instead of side by side. */
  stacked?: boolean;
}

export const VerticalBarChart = ({ chartData, stacked = false }: VerticalBarChartProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    const optionsData = {
      scales: {
        y: {
          stacked,
          grid: {
            display: true,
          },
        },
        x: {
          stacked,
          grid: {
            display: true,
          },
        },
      },
      responsive: true,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: true,
      },
      plugins: {
        legend: {
          position: 'bottom',
          display: chartData?.length > 1,
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
        },
      },
    };

    setOptions(optionsData);
  }, [stacked, chartData?.length]);

  const manuplateData = (chartData: any) => {
    if (chartData) {
      const tempdata: any = {
        labels: [],
        datasets: [],
      };
      const colors = barPalette('cb-Custom1', chartData.length).map(function (hex: string) {
        return '#' + hex;
      });
      chartData.forEach((d: any, i: any) => {
        const tempObj: any = {
          label: '',
          borderColor: d.colorPaletteCode ? d.colorPaletteCode : colors[i],
          backgroundColor: d.colorPaletteCode ? d.colorPaletteCode : colors[i],
          fill: false,
        };
        const tempdataArr: any = [];
        const tempdatalabel: any = [];
        let tempVal: any = '';
        tempObj.label = d.headerName;
        d.plots.forEach((d1: any) => {
          tempVal = NFormatterFun(d1.value, d1.symbol, 'Unit');
          tempVal = typeof tempVal == 'string' ? parseFloat(tempVal.replace(/,/g, '')) : tempVal;

          tempdataArr.push(d1.value && d1.value.toFixed(2));
          tempdatalabel.push(d1.name);
        });
        tempObj.data = tempdataArr;
        tempdata.labels = tempdatalabel;
        tempdata.datasets.push(tempObj);
      });
      return tempdata;
    }
  };

  const data = manuplateData(chartData);

  if (data) {
    return (
      <div className="custom-chart-size-2">
        <Bar
          className="cursorStyleOne"
          style={{ fill: 'none' }}
          data={data}
          options={options}
          width="400"
          height="275"
        />
      </div>
    );
  }

  return (
    <>
      <div className="">
        <img className="empty-state-3" src="/icons/Empty_icon.svg" alt="empty visual" />
      </div>
      <div className="">
        <label className="label-style-4 mt-3">{t('EMPTY_STATE.NO_DATA_FOUND')}</label>
      </div>
      <div className="w-50">
        <label className="label-style-5 mt-3">
          Please add the data to view corresponding visualisation here
        </label>
      </div>
    </>
  );
};
